module.exports = __webpack_public_path__ + "img/add.2039fb18.png";